/**
 * Jedyne miejsce, w ktorym siegamy po `import.meta.env`.
 * Dzieki temu konfiguracja jest typowana i latwa do podmiany w testach.
 */
export const env = {
  /**
   * Prefiks wszystkich wywolan API. Domyslnie `/api`, czyli zadania ida przez proxy
   * serwera deweloperskiego Vite do bramy — przegladarka widzi jeden origin,
   * wiec nie potrzebujemy CORS (brama go nie ma skonfigurowanego).
   */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',

  /**
   * Adres landing page'a (regulamin, polityka prywatnosci, kontakt).
   * Landing zyje na osobnym originie (`tenify.pl`), a aplikacja na `app.tenify.pl`,
   * wiec linki musza byc absolutne.
   */
  landingUrl: import.meta.env.VITE_LANDING_URL ?? 'https://tenify.pl',

  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
